import RSDK from '@sr/functions/rsdk/src';
import { InlineListSection, Resume } from '@sr/types';
import React from 'react';
import API from '../../utils/api';
import PlainText from '../tiptap-text/PlainText';
import getContentTypeLabel from './get-content-type-label';
import SectionFormContainer from './SectionFormContainer';

type Props = {
  resume: Resume;
  section: InlineListSection;
};

const InlineListForm = ({ resume, section }: Props) => {
  function updateContent(value: string) {
    API.resume.setProperty({
      path: `${resume.id}/sections/${section.sectionId}/list`,
      value,
    });
  }

  const srId = RSDK.getSectionPropSrId({
    sectionId: section.sectionId,
    sectionType: section.type,
    contentType: section.contentType,
    prop: 'list',
  });

  const placeholder = getContentTypeLabel(
    'inlinePlaceholder',
    section.contentType
  );

  if (section.type !== 'inline-list') return null;

  return (
    <SectionFormContainer resume={resume} sectionId={section.sectionId}>
      <PlainText
        srId={srId}
        content={section.list || ''}
        placeholder={placeholder}
        updateContent={updateContent}
      />
    </SectionFormContainer>
  );
};

export default InlineListForm;
